module.exports = __webpack_public_path__ + "statics/images/logo.1632492919061.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/img/logo.png
// module id = 126
// module chunks = 0